<mat-expansion-panel
	class="au-section-panel"
	hideToggle
	[disabled]="!dataForTable?.length"
	[expanded]="!!dataForTable?.length"
	(afterCollapse)="afterCollapseHandler()"
	(afterExpand)="afterExpandHandler()"
>
	<mat-expansion-panel-header class="section-header">
		<mat-panel-title>
			<span class="arrow" [class.rotate-right-90]="!isPanelOpen">
				<mat-icon
					class="icon"
					[ngClass]="dataForTable?.length ? '' : 'ghost-grey-icon'"
					svgIcon="arrow_down"
				></mat-icon>
			</span>
			<span class="section-name">{{ sectionConfig[entityType].name | translate }}</span>
			@if (dataForTable?.length) {
				<span class="circle-container">{{ dataForTable?.length }}</span>
			}
		</mat-panel-title>

		<mat-panel-description class="description">
			@if (sectionConfig[entityType].canOpenInDt) {
				<open-dt-from-workspace
					[entityName]="sectionConfig[entityType].entityName"
					[entities]="dataForTable"
					class="open-dt-button"
				/>
			}

			@if (existOnly) {
				<button mat-mini-fab class="surface-fab" (click)="useExisting($event)">
					<mat-icon svgIcon="add"></mat-icon>
				</button>
			}

			@if (!existOnly) {
				<button
					mat-mini-fab
					class="surface-fab"
					(click)="$event.stopPropagation()"
					[matMenuTriggerFor]="entityMenu"
				>
					<mat-icon svgIcon="add"></mat-icon>
				</button>
			}
		</mat-panel-description>
	</mat-expansion-panel-header>

	<au-table-layout
		[displayedColumns]="tableColumns"
		[data]="dataForTable"
		(cmmsDelete)="unlink.emit($event)"
		(tableRowClick)="viewEntity($event)"
		(selectColumn)="viewEntity($event)"
	>
	</au-table-layout>
</mat-expansion-panel>

<mat-menu
	#entityMenu="matMenu"
	class="au-select-actions"
	[xPosition]="'after'"
	[yPosition]="'below'"
>
	<button mat-menu-item (click)="useExisting($event)">
		<mat-icon svgIcon="{{ sectionConfig[entityType].entityIcon }}"></mat-icon>
		<span>{{ sectionConfig[entityType].existingEntityText | translate }}</span>
	</button>

	<button mat-menu-item (click)="addNew()">
		<mat-icon svgIcon="add"></mat-icon>
		<span>{{ sectionConfig[entityType].newEntityText | translate }}</span>
	</button>
</mat-menu>
